import {t} from "@lingui/core/macro";

import type {Conversation} from "@khan/guide-types";

import {appendConversationWithErrorMessage} from "./append-conversation-with-error-message.ts";

/**
 * Update the conversation to indicate an error.
 *
 * @param conversation The conversation to be modified.
 * @returns The updated conversation where, if the last message was outgoing,
 * that message is marked as an error; otherwise, an incoming error message is
 * appended.
 */
export const updateConversationWithError = (
    conversation: Conversation,
): Conversation => {
    const lastMessage = conversation[conversation.length - 1];
    if (lastMessage?.type === "outgoing") {
        return [
            ...conversation.slice(0, -1),
            {
                ...lastMessage,
                isError: true,
            },
        ];
    }

    return appendConversationWithErrorMessage(
        conversation,
        t`I'm not working right now because I might have technical problems. Please try again later.`,
    );
};
